import React from 'react';

const EmailManagerTopBar = () => (
  <div className="email-manager-top-bar-container shadow-[0_0_20px_6px_rgb(0,0,0,0.1)]" />
);

export default EmailManagerTopBar;
